import { render, staticRenderFns } from "./gestionesConPendientes.vue?vue&type=template&id=6c13db60&scoped=true"
import script from "./gestionesConPendientes.vue?vue&type=script&lang=js"
export * from "./gestionesConPendientes.vue?vue&type=script&lang=js"
import style0 from "./gestionesConPendientes.vue?vue&type=style&index=0&id=6c13db60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c13db60",
  null
  
)

export default component.exports